/**
 * How old a server check may be before what it saw is shown as out of date.
 * The same seven days the server uses (domain.CapabilityStaleAfter).
 */
export const OUT_OF_DATE_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

/** True when the evidence is older than the freshness window. Missing or unparseable time is not "old": it is unknown, which the caller shows as such. */
export function isOutOfDate(iso: string | null | undefined, now: number = Date.now()): boolean {
  if (!iso) return false;
  const at = Date.parse(iso);
  return Number.isFinite(at) && now - at > OUT_OF_DATE_AFTER_MS;
}

/** True when two timestamps name the same instant, however they are written. */
export function sameInstant(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b) return false;
  const x = Date.parse(a);
  const y = Date.parse(b);
  return Number.isFinite(x) && Number.isFinite(y) && x === y;
}

/**
 * The kernel release to show next to the architecture, or undefined.
 * Agents before the fix reported the operating system name ("linux") in
 * the kernel field; a release always carries a number ("6.8.0-45-generic").
 */
export function kernelRelease(kernel: string | null | undefined): string | undefined {
  const value = kernel?.trim();
  if (!value || !/\d/.test(value)) return undefined;
  return value;
}
